import { forwardRef } from 'react';
import { cn } from 'Utils/cn';
import Checkbox from 'Components/Atoms/Checkbox/Checkbox';
import PropTypes from 'prop-types';

const MultiselectItem = forwardRef(function MultiselectItem(props, ref) {
    const { className, active, ...checkboxProps } = props;

    return (
        <Checkbox
            ref={ref}
            fullWidth
            className={cn(
                'px-2 py-1.5 rounded-sm transition-colors cursor-pointer',
                active ? 'bg-gray-100' : 'hover:bg-gray-100',
                className,
            )}
            {...checkboxProps}
        />
    );
});

export default MultiselectItem;

MultiselectItem.propTypes = {
    checked: PropTypes.bool,
    indeterminate: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    active: PropTypes.bool,
};
